import React, { useContext } from "react";

import MediaTranslations from "./MediaTranslations";
import ContentContext from "../../../contexts/ContentContext";
import MasterMediaContext from "../../../contexts/MasterMediaContext";

import type { JSX } from "react";

import type { MediaTranslationsHandle } from "./MediaTranslations";
import type { GetMediaResponse } from "../../../api/MediaAPI.types";
import type { MasterMediaContextValues } from "../../../contexts/MasterMediaContext";
import type { ContentContextValues } from "../../content/ContentTabs";

export default function MasterLanguagesTabPanel(): JSX.Element | null {
  const { item: masterItem, childTranslationsRefs } =
    useContext<ContentContextValues>(ContentContext);
  const { activeTab } =
    useContext<MasterMediaContextValues>(MasterMediaContext);

  if (!masterItem.children?.length) return null;

  const getChildRef =
    (uuid: string) =>
    (element: MediaTranslationsHandle | null): void => {
      if (element) childTranslationsRefs.current?.set(uuid, element);
      else childTranslationsRefs.current?.delete(uuid);
    };

  return (
    <React.Fragment>
      {masterItem.children.map((child) => (
        <div
          key={child.uuid}
          className="ml-[1.875rem] w-full min-w-[12.5rem]"
          style={child.uuid !== activeTab ? { display: "none" } : undefined}
        >
          <MediaTranslations
            ref={getChildRef(child.uuid)}
            item={child as unknown as GetMediaResponse}
            masterUuid={masterItem.uuid}
          />
        </div>
      ))}
    </React.Fragment>
  );
}
